var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tixstock-tags-skeleton mt-15"},[_c('div',{staticClass:"tixstock-tags-box-skeleton"},[_c('div',{staticClass:"search-tag-skeleton"})])])])
}]

export { render, staticRenderFns }